/* House of Cotton Prints — cart drawer assurance strip (event-driven, no polling) */
(function () {
  var html = '<div class="hocp-cart-assure"><span><svg viewBox="0 0 24 24"><rect x="1.5" y="6" width="13" height="10" rx="1"/><path d="M14.5 9h4l3 3v4h-7z"/><circle cx="6" cy="18.5" r="1.7"/><circle cx="17.5" cy="18.5" r="1.7"/></svg>Free US shipping</span><span><svg viewBox="0 0 24 24"><path d="M20 12a8 8 0 1 1-2.3-5.7"/><path d="M20 3v5h-5"/><path d="M9 12l2 2 4-4"/></svg>30-day money-back guarantee</span></div>';
  function add() {
    var f = document.querySelector('.cart-drawer .drawer__footer, .cart-drawer__footer, cart-drawer .drawer__footer');
    if (f && !f.querySelector('.hocp-cart-assure')) {
      var d = document.createElement('div');
      d.innerHTML = html;
      f.insertBefore(d.firstChild, f.firstChild);
    }
  }
  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(add, 60); }
  document.addEventListener('DOMContentLoaded', function () {
    add();
    var drawer = document.querySelector('cart-drawer') || document.body;
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
    }
  });
  document.addEventListener('cart:refresh', schedule);
  document.addEventListener('cart-drawer:open', schedule);
})();

/* PDP sticky add-to-cart: lift it out of the product section (a transformed/clipped ancestor was trapping the fixed bar),
   and drive show/hide from the MAIN buy button, not from whichever <product-form> happens to come first in the DOM. */
(function () {
  function init() {
    var sticky = document.querySelector('sticky-product-form.product--sticky-form');
    if (!sticky || sticky.dataset.hocpLifted) return;
    sticky.dataset.hocpLifted = '1';
    document.body.appendChild(sticky);
    var mainBtn = null;
    var btns = document.querySelectorAll('product-form button[name="add"], .product-form__submit');
    for (var i = 0; i < btns.length; i++) { if (!sticky.contains(btns[i])) { mainBtn = btns[i]; break; } }
    if (!mainBtn) return;
    var show = function (on) {
      sticky.classList.toggle('product--sticky-form__active', on);
      sticky.classList.toggle('product--sticky-form__inactive', !on);
    };
    var mainVisible = true;
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (e) { mainVisible = e[0].isIntersecting; show(!mainVisible && window.scrollY > 200); }, { threshold: 0 }).observe(mainBtn);
    }
    window.addEventListener('scroll', function () {
      var r = mainBtn.getBoundingClientRect();
      var offscreen = r.bottom < 0 || r.top > window.innerHeight;
      show(offscreen && window.scrollY > 200);
    }, { passive: true });
    show(false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
})();
